import { SxProps, Theme } from '@mui/material/styles';

export const titleDpBestOfferSX: SxProps<Theme> = {
	fontWeight: 'bold',
	fontSize: {
        xs: 'var(--font-size-small)',
        sm: 'var(--font-size-md)',
    },
    textAlign: 'start',
    color: 'text.primary',
};

export const subtitleDpBestOfferSX: SxProps<Theme> = {
	fontWeight: 'normal',
	fontSize: {
        xs: 'var(--font-size-caption)',
        sm: 'var(--font-size-body)',
    },
    textAlign: 'start',
    color: 'text.primary',
};
